/**
 * Доска ОО — подписи людей, которых нет в её списке (архив 1С, В9, решение владельца 16.10). Без React и запросов.
 * Список доски — /api/staff (только неуволенные, и из них — операторы, isOperator в useOoDay). На даты 1С (и на любой прошлый
 * день) в составах, на МК и в админах зала стоят уволенные — чипы были подписаны id. Доска собирает id людей ДНЯ (с сервера, не
 * черновика: в черновик добавляют только из списка), берёт недостающие имена одним запросом /api/staff/names и подписывает
 * чип: оператор доски → имя с сервера → id. Список выбора людей не меняется.
 */

/** Сколько id сервер принимает за раз (apps/api/src/routes/staff/names.ts, NAMES_MAX). */
export const NAMES_MAX = 200;

/** Все люди дня на доске: составы игр (bookingId → id[]), МК (bookingId → mcId → id[]), админы залов (филиал → id[]). */
export function boardPeople(
  crews: Readonly<Record<string, readonly string[]>>,
  mc: Readonly<Record<string, Readonly<Record<string, readonly string[]>>>>,
  hall: Readonly<Record<string, readonly string[]>>,
): string[] {
  const out = new Set<string>();
  for (const ids of Object.values(crews)) for (const id of ids) out.add(id);
  for (const byMc of Object.values(mc)) for (const ids of Object.values(byMc)) for (const id of ids) out.add(id);
  for (const ids of Object.values(hall)) for (const id of ids) out.add(id);
  out.delete("");
  return [...out];
}

/** Чьих имён нет ни в списке доски, ни в уже полученных — по алфавиту id, без повторов, не больше NAMES_MAX. */
export function missingNames(ids: Iterable<string>, has: (id: string) => boolean): string[] {
  return [...new Set(ids)].filter((id) => id && !has(id)).sort().slice(0, NAMES_MAX);
}

/** URL запроса имён (пустой список — запроса нет). */
export const namesUrl = (ids: readonly string[]): string | null =>
  ids.length ? `/api/staff/names?ids=${encodeURIComponent(ids.join(","))}` : null;

/** Ответ { names: { id: имя } } → строковая карта; мусор отбрасывается. */
export function parseNames(r: unknown): Map<string, string> {
  const out = new Map<string, string>();
  const names = r && typeof r === "object" ? (r as { names?: unknown }).names : null;
  if (names && typeof names === "object") {
    for (const [id, nm] of Object.entries(names as Record<string, unknown>)) if (typeof nm === "string" && nm) out.set(id, nm);
  }
  return out;
}

/** Подпись человека доски: оператор доски → полученное имя → id (как было до 16.10). */
export function nameOfFactory(known: ReadonlyMap<string, { name: string }>, fetched: ReadonlyMap<string, string>): (id: string) => string {
  return (id) => known.get(id)?.name ?? fetched.get(id) ?? id;
}
